import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { ChapterView, getChapterOptions } from '@/module/Author/Chapter';

export const Route = createFileRoute('/_auth/author/_author/chapter/_chapter/$chapterId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { chapterId } = Route.useParams();
  const { data: chapter } = useSuspenseQuery(getChapterOptions(chapterId));

  return <ChapterView chapter={chapter} />;
}
